module.exports = {
      id: "step-100-index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#step-100-index-usage",
      toString: function () {
        return this.url;
      }
    }